module.exports = function(bootstrap) {
    bootstrap.run(['Service', 'appId', function(Service, appId) {
        new Service(
            {
                name: 'messageDeleteFlag',
                group: 'rbsmbl',
                url: '/rbsmbl/x-services/member/messages/v1/delstatusflag',

                update: function(messageList) {
                    var requestPayload = {
                        "reqUpdateDeleteStatusFlagRequest": {
                            "baseMessage": {
                                "exchangeType": "SENDREQUEST",
                                "headerVersion": "1.0",
                                "username": appId
                            },
                            "payload": {
                                "reqUpdateDeleteStatusFlagData": messageList
                            }
                        }
                    };

                    return this.post(requestPayload);
                }
            }
        );
    }]);
};